import Position from './Position';

/**
 * Class describing the values and functions of a Connection
 * Connections are used in the Wayfinding routing algorithm as a bridge between two Points
 * 
 * @export {Connection}
 * @class Connection
 */
export default class Connection {
    constructor(origin, destination, walkability, nonAda, bidirectional, stairs, crossFloor,
                         positionOrigin, positionDestination) {
        this._id = this.constructor.getIdentifier(origin, destination);
        this._origin = origin;
        this._destination = destination;
        this._walkability = walkability;
        this._nonAda = nonAda;
        this._bidirectional = bidirectional;
        this._stairs = stairs;
        this._crossFloor = crossFloor;
        this._distance = Position.getDistance(positionOrigin, positionDestination);
    }

    get id() {
        return this._id;
    }

    get origin() {
        return this._origin;
    }

    get destination() {
        return this._destination;
    }

    get walkability() {
        return this._walkability;
    }

    get bidirectional() {
        return this._bidirectional;
    }

    get stairs() {
        return this._stairs;
    }

    get crossFloor() {
        return this._crossFloor;
    }

    get distance() {
        return this._distance;
    }

    get nonAda() {
        return this._nonAda;
    }

    /**
     * Determines an identifier string for a connection based on the two points IDs it connects
     * 
     * @static
     * @param {string} origin 
     * @param {string} destination 
     * @returns {string}
     * @memberof Connection
     */
    static getIdentifier(origin, destination) {
        if(origin.toUpperCase() === destination.toUpperCase()) {
            return origin + "-" + destination;
        } else {
            return destination + "-" + origin;
        }
    } 
}



// WEBPACK FOOTER //
// ./src/classes/Connection.js